import { useMutation } from "@tanstack/react-query";
import type { DelayByShift } from "../../delays-manager/models/DelayByShift";
import {
  deleteDelay,
  justifyDelay,
  splitDelay,
  upsertDelay,
} from "../../delays-manager/repositories/DelaysManagerRepository";

export const useUpsertDelayMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      delayId: number | null;
      assetId: number | null;
      start: Date | null;
      end: Date | null;
      delayCodeId: number | null;
      delayCategoryId: number | null;
      comments: string | null;
    }) => {
      const resp = await upsertDelay(
        params.delayId,
        params.assetId,
        params.start,
        params.end,
        params.delayCodeId,
        params.delayCategoryId,
        params.comments,
      );
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useJustifyDelayMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      delayId: number;
      delayCodeId: number | null;
      delayCategoryId: number | null;
      comments: string | null;
    }) => {
      const resp = await justifyDelay(
        params.delayId,
        params.delayCodeId,
        params.delayCategoryId,
        params.comments,
      );
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useDeleteDelayMutation = () => {
  return useMutation({
    mutationFn: async (delayId: number) => {
      const resp = await deleteDelay(delayId);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useSplitDelayMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      delay1: DelayByShift;
      delay2: DelayByShift;
    }) => {
      const resp = await splitDelay(params.delay1, params.delay2);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};
